import { render, staticRenderFns } from "./kpsrRiskRegisterTL.vue?vue&type=template&id=29f3edf4"
import script from "./kpsrRiskRegisterTL.vue?vue&type=script&lang=js"
export * from "./kpsrRiskRegisterTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f3edf4')) {
      api.createRecord('29f3edf4', component.options)
    } else {
      api.reload('29f3edf4', component.options)
    }
    module.hot.accept("./kpsrRiskRegisterTL.vue?vue&type=template&id=29f3edf4", function () {
      api.rerender('29f3edf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/timeline/kpsrRiskRegisterTL.vue"
export default component.exports